import { useSyncExternalStore } from 'react';

/**
 * `matchMedia` is missing in jsdom (tests) and very old browsers. A missing
 * API counts as "no match" for layout queries, and as "reduce motion" for
 * the motion query, so animations resolve to their end state instantly.
 */
function hasMatchMedia(): boolean {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function';
}

export function prefersReducedMotion(): boolean {
  if (!hasMatchMedia()) return true;
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (notify) => {
      if (!hasMatchMedia()) return () => {};
      const mql = window.matchMedia(query);
      mql.addEventListener('change', notify);
      return () => mql.removeEventListener('change', notify);
    },
    () => (hasMatchMedia() ? window.matchMedia(query).matches : false),
    () => false,
  );
}

/** Same breakpoint as the `@media (max-width: 900px)` block in styles/preflight.css. */
export const MOBILE_QUERY = '(max-width: 900px)';
